import { getMessageSnippet } from '@/util/formatters';
import { createObjectDetailsRoute } from '@/router/utils';
import { handleTranslations, } from '@/layouts/_components/Notifications/_util/notification-factory';
export const handleTaggedInCommentNotification = (notification) => {
    const { type, payload: { brand, author, comment, object, objectType }, } = notification;
    return {
        getTranslations() {
            const translationPlaceholders = {
                user: author,
                message: getMessageSnippet(comment.message || '', 50),
            };
            return handleTranslations(type, translationPlaceholders);
        },
        getRoute() {
            return createObjectDetailsRoute(brand.id, object.id, objectType.id);
        },
    };
};
